<template>
   <v-dialog v-model="dialog" scrollable fullscreen hide-overlay transition="dialog-bottom-transition">
      <v-card class="dialog_card">
        <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-3" primary-title>
           <v-btn style="margin-left:10px;" class="btn_add" icon small @click="dialog = false">
              <v-icon>keyboard_backspace</v-icon>
            </v-btn>
           <div class="flex-grow-1"></div>
           Board List
           <div class="flex-grow-1"></div>
          <v-btn icon light @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text style="padding:0;">
            <v-container fluid>
                <v-dialog v-model="removeDialog" max-width="310">
                  <v-card>
                    <div class="loading" v-if="removeLoading">
                      <v-row align="center" justify="center"  class="fill-height" style="margin:0">
                        <v-progress-circular :size="50" :width="7" color="primary" indeterminate >
                          </v-progress-circular>
                      </v-row>
                    </div>
                    <v-card-title style="padding: 5px 5px 5px;font-size: 12pt !important;font-weight: bold;" class="dialog_title headline grey lighten-2" primary-title>
                      Board Remove
                      <div class="flex-grow-1"></div>
                      <v-btn icon light @click="removeDialog = false">
                        <v-icon>close</v-icon>
                      </v-btn>
                    </v-card-title>
                    <v-card-text>
                      <p style="padding:10px;">
                        Are you sure to remove this board ?
                      </p>
                    </v-card-text>
                    <v-card-actions>
                      <v-btn color="red darken-1" text  @click="removeDialog = false">
                        No
                      </v-btn>
                      <v-spacer></v-spacer>
                      <v-btn  color="green darken-1" text  @click="removeBoard()" >
                        Yes
                      </v-btn>
                    </v-card-actions>
                  </v-card>
                </v-dialog>
                <v-row  class="fill-height">
                  <div class="loading" v-if="loading">
                    <v-row align="center" justify="center" class="fill-height">
                      <v-progress-circular :size="25" :width="3" color="grey" indeterminate >
                          </v-progress-circular>
                    </v-row>
                  </div>
                <v-snackbar  v-model="errorLoading" color="error" :timeout="timeout" top="top">
                  {{errorMsg}}
                </v-snackbar>
                <v-col xs="12" sm="12" class="event_body" style="background-color:transparent">
                  <v-row class="urt_form fill-height" >
                        <v-col xs="12" sm="10" offset-sm="1" md="8" offset-md="2">
                            <v-card class="card_form">
                                    <v-data-table
                                      :headers="headerList"
                                      :items="result"
                                      :loading="isLoading"
                                      :options.sync="pagination"
                                      :server-items-length="totalItems"
                                    >
                                    <v-progress-linear  v-slot:progress color="blue" indeterminate></v-progress-linear>
                                   
                                    <template v-slot:top>
                                          <v-text-field class="table_search"  :class="{'xs_input': $vuetify.breakpoint.xs}"
                                                v-model="model"
                                                label="Search"
                                                data-vv-name="Search"
                                                solo
                                                v-on:keyup.enter="loadList"
                                                append-icon="search"
                                                @click:append="loadList"
                                                clearable
                                                @click:clear="clearSearch"
                                            >
                                             <template  style="margin-top:0" v-slot:prepend>
                                                <v-select
                                                  v-model="accessType"
                                                  :items="accessTypeList"
                                                  label="private"
                                                  @change="loadList"
                                                  solo
                                                ></v-select>
                                            </template>
                                            </v-text-field>
                                      </template>
                                      <!-- <template v-slot:item.bid="{ item }">
                                            <div style="cursor:pointer;" >{{ item.data && item.data.bid ? item.data.bid : 'noid'}}</div>
                                      </template>
                                      <template v-slot:item.name="{ item }">
                                            <div style="cursor:pointer;" @click.stop="detailJson(item)">{{item.qname ? item.qname : item.name}}</div>
                                            <div style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.name ? item.name : item.qname}}</div>
                                      </template>
                                       <template v-slot:item.updateDate="{ item }">
                                            <div style="cursor:pointer;" @click.stop="detailJson(item)">{{item.updateDate | formatTime}}</div>
                                      </template>
                                       <template v-slot:item.type="{ item }">
                                            <div style="cursor:pointer;" @click.stop="detailJson(item)">{{item.type}}</div>
                                      </template> -->
                                      <template v-slot:item.name="{ item }">
                                              <span style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.name }}</span>
                                        </template>
                                        <template v-slot:item.qname="{ item }">
                                              <span style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.qname }}</span>
                                        </template>
                                        <template v-slot:item.qcode="{ item }">
                                              <span style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.qcode }}</span>
                                        </template>
                                        <template v-slot:item.updateDate="{ item }">
                                              <span style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.updateDate | formatTime }}</span>
                                        </template>
                                        <template v-slot:item.type="{ item }">
                                              <span style="cursor:pointer;" @click.stop="detailJson(item)">{{ item.type }}</span>
                                        </template>
                                        <template v-slot:item.action="{ item }">
                                           <v-btn v-if="user.Uid == item.uid" style="margin-right:10px;" class="btn_add" color="grey lighten-4" fab small light  @click.stop="preRemoveBoard(item)">
                                                <v-icon>delete</v-icon>
                                              </v-btn>    
                                            <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-4" fab small light  @click.stop="cloneBoard(item)">
                                              <v-icon>content_copy</v-icon>
                                            </v-btn>    
                                        </template>
                                      <!-- <template v-slot:body="{ items }">
                                        <tbody>
                                          <tr style="cursor:pointer;text-align:left" v-for="(item, index) in items" :key="index" >
                                            <td @click.stop="detailJson(item)">{{ item.name }}</td>
                                            <td @click.stop="detailJson(item)">{{ item.qname }}</td>
                                            <td @click.stop="detailJson(item)">{{ item.qcode }}</td>
                                            <td @click.stop="detailJson(item)" class="hidden-xs-only">{{ item.updateDate | formatTime }}</td>
                                            <td @click.stop="detailJson(item)" class="hidden-xs-only">{{ item.type }}</td>
                                            <td>
                                              <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-4" fab small light  @click.stop="preRemoveBoard(item)">
                                                <v-icon>delete</v-icon>
                                              </v-btn>    
                                            </td>
                                            <td>
                                            <v-btn style="margin-right:10px;" class="btn_add" color="grey lighten-4" fab small light  @click.stop="cloneBoard(item)">
                                              <v-icon>content_copy</v-icon>
                                            </v-btn>    
                                            </td>
                                          </tr>
                                        </tbody>
                                      </template> -->
                                     
                                      <template v-slot:no-data>
                                        <v-layout align-center justify-center row>
                                          <v-btn color="primary" class="table_btn" small outlined light @click="loadList()">Try Fetch</v-btn>
                                        </v-layout>
                                      </template>
                                    </v-data-table>
                            </v-card>
                        </v-col>
                    </v-row>
                </v-col>
              </v-row>
            </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <!-- <v-card-actions style="padding:5px;padding-right:10px;">
          <v-btn class="dialog_btn" color="primary" text @click="dialog = false">
            Cancel
          </v-btn>
          <div class="flex-grow-1"></div>
        </v-card-actions> -->
      </v-card>
    </v-dialog>  
</template>
<script>
import { setTimeout, setInterval } from 'timers';
import { isNumber } from 'util';
import parse from "url-parse";
import webmms from "webmms-client";
import { set as setCookie, get as getCookie, remove as removeCookie } from "es-cookie";
import { mapGetters } from 'vuex';
import VueJsonPretty from 'vue-json-pretty';
import conf from '@/config/config';

export default {
    id: "#builderDialog",
    $_veeValidate: {
        validator: 'new'
    },
     data () {
      return {
        value: '',
        dialogData: {},
        dialogState: false,
        deleteDialog: false,
        loading: false,
        removeLoading: false,
        successed: false,
        dialog: false,
        headers: [
          { text: 'Name', value: 'name' },
          { text: 'QName', value: 'qname' },
          { text: 'QCode', value: 'qcode' },
          { text: 'Date/Time', value: 'updateDate' },
          { text: 'Type', value: 'type',sortable: false },
          { text: 'Action', value: 'action', sortable: false },
          // { text: 'Delete', sortable: false },
          // { text: 'Clone', sortable: false }
          //{ text: 'Tag', value: 'tag',sortable: false,hide: 'xs' }
          //{ text: 'Actions', value: 'name', sortable: false }
        ],
        typeList: [
          'object',
          'board'
        ],
        accessTypeList : [
          'private',
          'public'
        ],
        accessType: 'private',
        desserts: [],
        pagination: {},
        totalItems : 0,
        editedIndex: -1,
        editMode: false,
        editItem: {

        },
        removeDialog: false,
        removeBoardItem: null,
        editTempItem: {},
        dialogState: false,
        dialogLoading: false,
        dialogIsNew: false,
        dialogIndex: 0,
         eiInfo: {
          eiName: '',
          eiTag: '',
          ddn : ''
        },
        webmmsOptions : {
            EiToken: '',
            SToken: '',
            UToken: ''
        },
        yp:{
          ddn: conf.objstore,
          topic: '',
          func: 'object',
          args: null
        },
        errorList: [],
        error: true,
        errorLoading: false,
        errorMsg: '',
        result: [],
        isLoading: true,
        model: null,
        typeModel: 'board',
        search: null,
        timeout: 3000,
        mmsReady: false,
        mms: null
      }
    },
    
     computed: {
     
      headerList(){
        let bp = this.$vuetify.breakpoint;
        let vm= this
        return this.headers.filter(h => {
          if (!h.hide) return true;
          let hide = h.hide
          if (!Array.isArray(hide)) hide = [hide]
          return !hide.find(e => {
            if (typeof e === 'string') return bp[e]
          });
        });
      },
      user (){
        return this.$store.getters.user;
      }
    },
    watch: {
      dialog (val) {
        val || this.close()
      },
      pagination: {
        handler () {
          this.loadList();
        },
        deep: true       
      },
      model: {
        handler(){
          this.pagination.page = 1;
        },
        deep: true
      }
    },
    components: {
      VueJsonPretty
    },
    async created() {
       this.startMMS();
    },
    async beforeMount() {
       //await this.subscribeMMS();
    },
    beforeDestroy() {
      //this.removeEvent();
    },
     methods: {
      close() {
        this.$emit('closeDialog', false);
      },
      preRemoveBoard(item){
        this.removeBoardItem = item;
        this.removeDialog = true;
      },
      async removeBoard(){
          let result = await this.removeById(this.removeBoardItem._id);
          if(result){
            this.removeDialog = false;
            await this.loadList();
          }
      },
      async detailJson(item){
        if(item.uid != this.user.Uid){
           this.errorMsg = 'You do not have permission to edit this record';
           this.errorLoading = true;
           return;
         }
         this.editTempItem = await this.loadById(item._id);
          let newItem =Object.assign({},this.editTempItem);
          //this.deleteObjectKey(newItem);
          if(!newItem.qname)
            newItem.qname = newItem.name;
          if(!newItem.qcode && newItem.data)
            newItem.qcode = newItem.data.bid;
            
          this.dialogData = newItem;
          this.dialog = false;
          this.$emit('saveDialog', this.dialogData);
          //this.deleteObjectKey(newItem);
      },
      async cloneBoard(item){
          this.editTempItem = await this.loadById(item._id);
          let newItem = Object.assign({},this.editTempItem);
          this.deleteObjectKey(newItem);
          newItem.qname = null;
          newItem.name = null;
          newItem.qcode = null;          
          newItem.uid = this.user.Uid;          
          this.dialogData = newItem;
          this.dialog = false;
          console.log(this.dialogData);
          this.$emit('cloneDialog', this.dialogData);
      },
      async callDeleteJson(){
         if(!this.editItem.dialogIsNew)
            await this.deleteJson(this.editItem);
      },
      async deleteJson(item, index){
        // if(!this.checkWebMMSState())
        //   return;

        let newItem =Object.assign({},item);
        //this.editTempItem = item;
        this.deleteObjectKey(newItem);
        this.editItem = newItem;
        //this.editItem.oid = this.editTempItem.oid;
        //this.dialogIndex = index;

        item.deleteDialog = false;
        //this.isLoading = true;
        this.isLoading = true;
        this.dialogLoading = true;
        let [{ Reply: result }] = await this.$mms.callMMS({
              topic: "",
              DDN: this.yp.ddn,
              func: "obj://delete",
              payload: {
                "condition" : {
                  "name" : this.editItem.name
                }
              }
          });
          this.isLoading = false;
          this.dialogLoading = false;
        //this.isLoading = false;

        if(result.ErrMsg == 'OK'){
          this.dialogState = false;
            this.result.splice(this.dialogIndex, 1);
          }else{
            this.errorMsg = result.ErrMsg;
            this.error = true;
          }

      },
      clearSearch(){
          this.model = '';
          this.loadList();
      },
      async loadById(id){
          let payload;

          payload = {
              noCache: true,
              allData: true,
              condition: {_id : id}
          }

          console.log(payload);

          // if(!this.checkWebMMSState())
          //   return;

          this.isLoading = true;

          let res = await this.$mms.callMMS({
              topic: this.yp.topic,
              DDN: this.yp.ddn,
              func: "obj://list",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  return data.Data[0];
                }else{
                  return {};
                }
            }

      },
      async removeById(id){
          let payload;

          payload = {
              _id : id
          }
          console.log(payload);        

          this.removeLoading = true;

          let res = await this.$mms.callMMS({
              topic: this.yp.topic,
              DDN: this.yp.ddn,
              func: "obj://delete",
              payload: payload
          });

          this.removeLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  return true;
                }else{
                  this.errorMsg = result.Reply ? result.Reply.ErrMsg : result.IN.State.ErrMsg;
                  this.errorLoading = true;
                  return false;
                }
            }

      },
      async loadList(){
          let payload;
          console.log(this.pagination);
          const { sortBy, sortDesc, page, itemsPerPage  } = this.pagination;

          let sort = {};
          if (sortBy && sortBy.length === 1 && sortDesc.length === 1) {
              sort[sortBy[0]] = sortDesc[0] ? -1 : 1;
          }else{
            sort = {name : 1};
          }

          payload = {
              page: page - 1,
              limit: itemsPerPage,
              sort : sort,
              noCache: true,
              allData: true,
              exclude: "-data.board"
          }

          if(!this.model || this.model.length == 0)
          {
            payload.condition = {uid: this.user.Uid};

          }else{
              if(this.model.startsWith('/'))
                payload.condition = { vpath : {$regex: this.model + '.*'}, uid: this.user.Uid};
             else if(this.model.startsWith('#'))
                payload.condition = { tag : {$regex: this.model.substring(1) + '.*', $options: 'i'}, uid: this.user.Uid};
             else if(this.model.startsWith('name:'))
                payload.condition = { $and: [{$or: [{qname : { $regex: this.model.substring(5) + '.*', $options: 'i'}},{name : { $regex: this.model.substring(5) + '.*', $options: 'i'}}]}], uid: this.user.Uid};
             else if(this.model.startsWith('bid:'))
                payload.condition = { "data.bid" : { $regex: this.model.substring(4) + '.*'}, uid: this.user.Uid};
             else if(this.model.startsWith('p:bid:'))
                payload.condition = {  "data.bid" : {$regex: this.model.substring(6) + '.*'}, $or: [{access: 'public'}, {access: null}]};
             else if(this.model.startsWith('p:name:'))
                payload.condition = {  $and: [ {$or: [{qname : {$regex: this.model.substring(8) + '.*', $options: 'i'}, },{name : {$regex: this.model.substring(8) + '.*', $options: 'i'}}]} ], $or: [{access: 'public'}, {access: null}]};
             else if(this.model.startsWith('p:'))
                payload.condition = {  $or: [{access: 'public'}, {access: null}]};
             else
                payload.condition = {$and: [{$or: [{ qname : {$regex: this.model + '.*', $options: 'i'}},{ name : {$regex: this.model + '.*', $options: 'i'}}]}], uid: this.user.Uid};
          }

          if(this.accessType == 'private'){
            //payload.condition.access = 'private';
          }
          else {
            //payload.condition.$and = { $or : [{access: 'public'}, {access: null}]};
            delete payload.condition['uid'];
          }

          payload.condition.type = this.typeModel;

          console.log(payload);

          // if(!this.checkWebMMSState())
          //   return;

          this.isLoading = true;
          // let [{ Reply: result, IN: state }] = await this.$mms.callMMS({
          //     topic: "",
          //     DDN: this.yp.ddn,
          //     func: "obj://list",
          //     payload: payload
          // });

          let res = await this.$mms.callMMS({
              topic: this.yp.topic,
              DDN: this.yp.ddn,
              func: "obj://list",
              payload: payload
          });

          this.isLoading = false;

          if(res){
                let result;
                if(typeof res == 'object')
                    result = res;
                else
                    result = res[0];

                if(!result)
                  return;
                console.log(result);

                if(result[0]){
                  result = result[0];
                }

                if(result.Reply && result.Reply.ErrMsg == 'OK'){
                  let data = result.Reply.Data;
                  this.result = data.Data.map(item => {
                    //this.deleteObjectKey(item);
                    return item;
                  });
                  this.totalItems = data.TotalCount;
                }else{
                  this.result = [];
                  this.totalItems = 0;
                }
            }


          // this.result = this.entries.filter( item => {
          //     return item.name.toLowerCase().includes(this.model.toLowerCase());
          // });
      },
      deleteObjectKey(item){
          this.$delete(item, '_w');
          this.$delete(item, '_id');
          this.$delete(item, 'oid');
          this.$delete(item, '__v');
          //this.$delete(item, 'path');
          this.$delete(item, 'uid');
          this.$delete(item, 'insertDate');
          this.$delete(item, 'updateDate');
          this.$delete(item, 'parentId');
          this.$delete(item, 'objects');
          this.$delete(item, 'showOperand');
      },
      checkWebMMSState(){
        if(!this.mmsReady)
        {
          this.errorMsg = "WebMMS is not connected or registered.";
          this.error = true;
          return false;
        }else return  true;

      },
      startMMS(){
          // this.mms =  webmms({
          //   wsurl: conf.wsurl,
          //   EiToken: getCookie("obj-EiToken") || "",
          //   SToken: getCookie("obj-SToken") || ""
          // });
      },
      // async subscribeMMS() {
      //   this.removeEvent = this.$mms.on("registered", async reply => {
      //       //console.log('reply=%s', JSON.stringify(reply))
      //        if(reply.ErrMsg == "OK"){
      //           this.eiInfo.ddn = reply.result.DDN;
      //           this.webmmsOptions.EiToken = reply.result.EiToken;
      //           this.webmmsOptions.SToken = reply.result.SToken;
      //           this.webmmsOptions.UToken = reply.result.UToken;
      //           if(this.eiInfo.eiName == ''){
      //             this.eiInfo.eiName = reply.result.EiName ? reply.result.EiName : 'jb' + this.makeId(5);
      //           }
      //            if(this.eiInfo.eiTag == ''){
      //             this.eiInfo.eiTag = reply.result.EiTag ? reply.result.EiTag : '';
      //           }
      //           this.mmsReady = true;
      //           this.error = false;
      //        }else{
      //           this.mmsReady = false;
      //           this.error = false;
      //        }

      //        let expiredTime = 60 * 60 * 24 * 30 * 12;

      //        setCookie("obj-EiToken", this.webmmsOptions.EiToken);
      //        setCookie("obj-SToken", this.webmmsOptions.SToken);


      //        console.log('regtoCenter: %s', reply.ErrMsg);

      //       let deviceInfo = {"DDN":this.eiInfo.ddn,"EiOwner":"","EiName":this.eiInfo.eiName,"EiType":".page","EiTag":this.eiInfo.eiTag,"EiLoc":""};
      //       let result = await this.$mms.setDeviceInfo(deviceInfo);

      //       console.log('SetDevice reply=%s', JSON.stringify(result));

      //        this.loadList();

      //   });

      //   this.$mms.on('message', (method, from, data, body) => {
      //        this.mmsReady = true;
      //        this.error = false;
      //        console.log('rcve: from=%s, data=%s', from, JSON.stringify(data));
      //       if(typeof data == 'object' && !data.from)
      //         data.from = from;
      //       //body.sender = data;
      //       if(data)
      //       {

      //         //this.eventList.push(data.data);
      //         //this.setLog({From : from, Data: data}, 'In');

      //       }
      //   });

      //   this.$mms.on('state', msg => {
      //       console.log('WS error: %s', msg);
      //       this.mmsReady = false;
      //       this.error = true;
      //       this.loading = false;
      //   });

      //   this.$mms.on('disconnect', msg => {
      //       this.mmsReady = false;
      //       this.error = true;
      //       this.loading = false;
      //   });

      //   this.$mms.on('error', err => {
      //       this.mmsReady = false;
      //       this.error = true;
      //       this.loading = false;
      //   });

      //   this.$mms.on('connect_error', err => {
      //       this.mmsReady = false;
      //       this.error = true;
      //       this.loading = false;
      //   });

      //   this.$mms.on('connect_timeout', err => {
      //       this.mmsReady = false;
      //       this.error = true;
      //       this.loading = false;
      //   });
      // },
       onJsonChange (value) {
        //console.log('change value:', value)
      },
      onJsonSave (value){
        //console.log('save value:', value);
      },
      onJsonError (error){
         //console.log('error:', error);
      }
    }
}
</script>
<style scoped>

.btn_add{
    width: 30px !important;
    height: 30px !important;
}
.json_editor{
  min-height: 500px;
  height: 100%;
}
.event_body{
   /* background-color:#e9fafb; */
}
.event_card{
   box-shadow: none;
   background-color: transparent !important;
}
.header_layout{
  margin-top: -5px;
}
.event_header{
  /* background-color:#e9fafb; */
  height: 45px;
  box-shadow: none;
  padding-top: 10px;
  border:none;
  position: fixed;
  top: 0;
  z-index: 2;
}

.card_form{
  margin:5px;
  margin-top: 60px;
}

.view_footer{
   z-index: 2;
}
.flash_box{
  float: right;
  /* margin-right: -15px; */
}
.event_status{
  height: 25px;
  width: 25px;
  border-radius: 50%;
  display: inline-block;
  margin-left: 6px;
  vertical-align: middle;
  margin-top: -5px;
}
.event_status_connect{
   background-color:#08b325;
   border-color: #08b325;
}
.event_status_disconnect{
   background-color: #d22727;
   border-color: #b72626;
}
.event_header_title{
  font-weight: bold;
   font-size: 15pt;
  margin: 0;
}

.event_header .v-toolbar__content{
   height: 45px;
}
.list{
  background-color:#f2f3f3;
  padding: 0 0 0;
  box-shadow: none;
  border:none;
  margin-top: 0;
}
  .event-action{
    margin-right:15px;
    min-width: auto;
    line-height: 18pt;
  }

  .loading{
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left:0;
  z-index: 50;
  background-color: rgba(255, 255, 255, 0.4196078431372549);
}

  .list-item{
    border-bottom: 1px solid #c9c8c8;
  }
.table_btn{
  text-transform: unset;
}
.btn_add{
    /* bottom: 0;
    position: fixed;
    margin: 0 0 16px 16px;
    z-index: 5; */
    width: 30px !important;
    height: 30px !important;
}
.btn_add i{
  font-size: 20px !important;
}
</style>

<style lang="scss">
.card_form{
  .v-input__prepend-outer{
      margin-top: 0 !important;
  }
}
.v-list__tile--avatar{
   height: 35px !important;
}
.v-list__tile__sub-title {
    font-size: 10pt;
}
.event_header .v-toolbar__content{
   height: 45px !important;
       display: block;
}
.item_form .v-text-field__details{
  margin: 0 !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
td{
  vertical-align: middle !important;
}

.jsoneditor-vue{
  height: 100%;
}
.json-save-btn{
  padding: 8px 35px !important;
  margin-bottom: 20px;
}
.yp_edit > div{
      padding-left: 10px;
    padding-right: 10px;
}
div.jsoneditor-menu{
  background-color: #dfdede !important;
  border-bottom: 1px solid #bcbcbc !important;
  color: #0c0b0b !important;
}
div.jsoneditor-menu button{
  color: #0c0b0b !important;
}
div.jsoneditor{
  border: 1px solid #b2b3b4 !important;
}
div.jsoneditor-menu > button, div.jsoneditor-menu > div.jsoneditor-modes > button{
  color: #0c0b0b !important;
}
.jsoneditor-compact,.jsoneditor-format{
 color: #0c0b0b !important;
}
.jsoneditor-poweredBy{
  color: #dfdede !important;
}
.yp_toolbar .v-toolbar__content{
height: 45px !important;
}
.xs_input .v-input__control{
    min-height: 37px !important;
}
.xs_input .v-input__slot{
    margin-bottom: 3px !important;
}
.xs_input .v-label{
  font-size: 12px !important;
}
.table_header .v-toolbar__content{
  height: 70px !important;
}
.table_search{
      padding: 5px !important;
}
.table_search .v-input__control {
  min-height: 40px !important;
}
.table_combo .v-input__control {
  min-height: 40px !important;
}
</style>